import ReactDirective from "acl-ui/angular/reactDirective.umd";
import ActionButtons from "@viz-ui/components/ActionButtons";

angular
  .module("highbond.visualizer.actionButtons", [])
  .directive("vizActionButtons", ReactDirective.getFactory(ActionButtons));
